import { QualificationDTO } from './QualificationDTO';
import { Type } from 'class-transformer';

export class QualificationListDTO {
  @Type(() => QualificationDTO)
  public qualifications: QualificationDTO[];
}